import React, { useEffect } from "react"
import sanityClient from "@sanity/client"
import { store } from "../../config"
import { productFragment } from "../queries/groq"
import { objectCustomImage } from "../queries/groq/partials"
import Template from "@app/components/Product/Product"
import { GetServerDataProps, PageProps } from "gatsby"

import { useRecentlyViewedContext } from "@app/providers/recentlyViewed"
import { useCore } from "@app/hooks/useCore"
import { useLazyQuery } from "@apollo/client"

export type Props = PageProps<GatsbyTypes.TemplateProductQuery, GatsbyTypes.TemplateProductQueryVariables>

export async function getServerData(context: GetServerDataProps) {
  const {
    pageContext: { handle },
  } = context

  const client = sanityClient({
    dataset: store.sanityDataset,
    projectId: store.sanityProjectId,
    apiVersion: store.sanityApiVersion,
    token: store.sanityToken,
    useCdn: true,
  })

  try {
    const response = await client.fetch(`
      {
        "product": *[_type == "product" && shopify.handle == "${handle}"][0] {
          metadata {
            ...,
            ${objectCustomImage}
          },
          ${productFragment},
        }
      }
    `)
    return {
      status: 200,
      props: response,
    }
  } catch (error) {
    console.log((error as Error).message)
    return {
      status: 500,
    }
  }
}

const Component: React.FC<Props> = ({ serverData, ...props }) => {
  const {
    graphql: {
      queries: { GET_PRODUCT_AVAILABILITY, GET_PRODUCTS_BY_HANDLE },
    },
  } = useCore()
  const { addRecentlyViewed } = useRecentlyViewedContext()
  const {
    product: {
      //@ts-ignore
      shopify: { handle, raw },
      //@ts-ignore
      primaryCollection,
    },
  } = serverData
  const countryCode = "AU"
  let rawProduct: any = undefined
  try {
    rawProduct = {
      ...JSON.parse(raw),
      primaryCollection,
    }
  } catch (err) {
    console.error("Error parsing raw shopify product")
  }

  const [getProduct, { data: live, called }] = useLazyQuery(GET_PRODUCT_AVAILABILITY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: { handle, countryCode },
  })
  const [getProductFull, { data: fullLive, called: fullCalled }] = useLazyQuery(GET_PRODUCTS_BY_HANDLE([handle]), {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: {
      countryCode,
      firstCollections: 20,
      firstImages: 0,
      firstMedia: 0,
      firstMetafields: 0,
      firstVariants: 0,
    },
  })
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!live) {
      if (!handle || called) return
      addRecentlyViewed(rawProduct)
      getProduct()
    } else if (!fullLive) {
      if (!handle || fullCalled) return
      getProductFull()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handle, called, getProduct, live, fullCalled, getProductFull, addRecentlyViewed])

  return <Template {...props} {...serverData} />
}
export default Component
